document.addEventListener('DOMContentLoaded', () => {
  const stickyAtc = document.getElementById('sticky-atc');
  const mainAtc = document.querySelector('button[name="add"]');

  if (!stickyAtc || !mainAtc) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyAtc.classList.add('hidden');
      } else {
        stickyAtc.classList.remove('hidden');
      }
    },
    { threshold: 0 }
  );

  observer.observe(mainAtc);
});

document.addEventListener('variant:change', function (event) {
  const priceEl = document.querySelector('.sticky-atc__price');
  if (!priceEl) return;

  const variant = event.detail.variant;
  if (!variant) return;

  priceEl.innerHTML = Shopify.formatMoney(
    variant.price,
    window.theme.moneyFormat
  );
});
